import React from "react";
import "./DrawerToggleButton.css";

const DrawerToggleButton = props => (
    (!props.isToggle)?
    <button className="toggle-button" onClick={props.click}>
        <div className="toggle-button__line" />
        <div className="toggle-button__line" />
        <div className="toggle-button__line" />
    </button>: <a className="h3 "><i className="far fa-times" onClick={props.click}></i></a>

);

export default DrawerToggleButton;
